import React, { useMemo } from 'react';
import { Image, View } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

// "Michael Lukian" -> "ML"; single names give their first two letters.
const getUserInitials = (name) => {
	const trimmed = (name || '').trim();
	if (!trimmed) {
		return '?';
	}

	const nameParts = trimmed.split(' ').filter(Boolean);
	if (nameParts.length === 1) {
		return nameParts[0].slice(0, 2).toUpperCase();
	}

	return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
};

const UserAvatar = ({
	name,
	photoUrl,
	size = 72,
	style,
	initialsStyle,
}) => {
	const styles = useThemedStyles(createStyles);
	const initials = useMemo(() => getUserInitials(name), [name]);

	return (
		<View style={[styles.wrapper, { width: size, height: size, borderRadius: size / 2 }, style]}>
			{
				photoUrl ? (
					<Image
						source={{ uri: photoUrl }}
						style={styles.photo}
						accessibilityIgnoresInvertColors={true}
					/>
				) : (
					<Text style={[styles.initials, { fontSize: Math.max(16, size * 0.32) }, initialsStyle]}>
						{initials}
					</Text>
				)
			}
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	wrapper: {
		backgroundColor: colors.chip,
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
		borderWidth: 2,
		borderColor: colors.borderStrong,
	},
	photo: {
		width: '100%',
		height: '100%',
		resizeMode: 'cover',
	},
	initials: {
		color: colors.onChip,
		fontWeight: '600',
		letterSpacing: 1,
	},
});

export default UserAvatar;
